export default {
  site: {
    name: "KakobuyFinds",
    tagline: "Twoja Niezależna Baza Produktów",
  },
  nav: {
    home: "Strona Główna",
    categories: "Kategorie",
    about: "O Nas",
    blog: "Poradnik",
    contact: "Kontakt",
  },
  hero: {
    h1Line1: "Kakobuy Spreadsheet",
    h1Line2: "Polska – Znaleziska 2026",
    subtitle: "Odkrywaj tysiące produktów, porównuj popularne listy i znajdź najlepsze okazje dzięki aktualnym bazom Kakobuy Spreadsheet.",
    primaryCta: "Przeglądaj Sheet",
    secondaryCta: "Buy It Now",
    trust1: "Aktualne listy produktów",
    trust2: "Szczegółowe porównania",
    trust3: "Niezależne poradniki",
    trust4: "Bezpieczne informacje",
  },
  categories: {
    title: "Wybierz Swoją Kategorię",
    subtitle: "Przeglądaj tysiące produktów w naszych spreadsheetach",
    dropdownLabel: "Wybierz kategorię...",
    exploreButton: "Przeglądaj",
  },
  about: {
    titleLine1: "Twoja Niezależna",
    titleLine2: "Baza Produktów",
    titleLine3: "Kakobuy",
    description: "KakobuyFinds to niezależna platforma badawcza i porównawcza, która pomaga użytkownikom odkrywać najlepsze produkty, porównywać ceny i znajdować najciekawsze okazje zakupowe. Nie jesteśmy oficjalną stroną Kakobuy – jesteśmy Twoim przewodnikiem po świecie spreadsheetów produktowych.",
    cta: "Odkryj Kaspreadsheet",
  },
  products: {
    title: "Najnowsze Produkty",
    tag: "Trending Now",
    updated: "Zaktualizowano: dziś",
  },
  cta: {
    title: "Gotowy na Zakupy?",
    subtitle: "Przejdź do pełnej bazy produktów i odkryj tysiące okazji na Kaspreadsheet. Wszystkie produkty w jednym miejscu, regularnie aktualizowane.",
    button: "Zobacz Pełną Bazę",
  },
  testimonial: {
    title: "(Co Mówią Użytkownicy)",
    rating: "4.9/5",
    quote: "Dzięki KakobuyFinds zaoszczędziłem dziesiątki godzin na szukaniu produktów. Spreadsheety są zawsze aktualne, a kategorie świetnie zorganizowane. To moje główne narzędzie do researchu przed zakupami.",
    author: "Michał K.",
    role: "Stały użytkownik od 2024",
  },
  article: {
    title: "Kakobuy Spreadsheet – Kompletny Przewodnik",
    excerpt: "Dowiedz się wszystkiego o Kakobuy Spreadsheet: czym jest, jak działa, jakie produkty znajdziesz i dlaczego warto z niego korzystać. Kompletny przewodnik dla początkujących i zaawansowanych użytkowników.",
    readMore: "Czytaj Cały Artykuł",
    category: "Poradnik",
  },
  footer: {
    newsletterTitle: "Bądź na Bieżąco",
    newsletterSubtitle: "Zapisz się do newslettera i otrzymuj informacje o nowych spreadsheetach i promocjach.",
    newsletterPlaceholder: "Twój adres email",
    newsletterButton: "Zapisz Się",
    brandDesc: "Niezależna platforma odkrywania produktów Kakobuy. Największa baza spreadsheetów w Polsce.",
    copyright: "© 2026 KakobuyFinds. Wszelkie prawa zastrzeżone.",
    quickLinks: "SZYBKIE LINKI",
    categoriesFooter: "KATEGORIE",
    guides: "PORADNIKI",
    legal: "INFORMACJE",
  },
  actions: {
    kakobuySheet: "Kakobuy Sheet",
    buyItNow: "Buy It Now",
    search: "Szukaj produktów...",
  },
};